import { update_cart_event } from "@/utils/gtm";

const itemExists = (cartItems, newItem) => {
  return cartItems?.some((item) => item.item_id === newItem.item_id);
};

export const cartReducer = (state, action) => {
  switch (action.type) {
    case "get_cart":
      return {
        ...state,
        cart: action?.payload,
        cartItems: action?.payload?.items,
      };
    case "add_bundle":
      const items = action.payload;
      const updatedCartItems = state?.cartItems?.map((item) => {
        if (itemExists(state?.cartItems, item) && typeof item == "object") {
          // Item exists, update quantity
          const newItem = items?.find(
            (newItem) => newItem.item_id === item.item_id
          );
          return { ...item, quantity: (item.qty = newItem?.qty) };
        }
        return item;
      });
      // Items that don't exist, add them to cartItems
      const newItems = items?.filter(
        (newItem) => !itemExists(state.cartItems, newItem)
      );
      const mergedCartItems =
        updatedCartItems?.length && newItems?.length
          ? [...updatedCartItems, ...newItems]
          : [];

      return { ...state, cartItems: mergedCartItems };
    case "add_item":
      const newItem = action?.payload;

      // Finding the index of the item in the cart, if it exists
      const itemIndex = state?.cartItems?.findIndex(
        (item) => item.item_id === newItem.item_id
      );

      let newCartItems = [];
      if (itemIndex >= 0) {
        // If the item is already in the cart, update its quantity
        newCartItems = state.cartItems.map((item, index) => {
          if (index === itemIndex) {
            return { ...item, qty: newItem?.qty };
          }
          return item;
        });
      } else {
        // If the item is not in the cart, add it to the cart
        newCartItems = [...(state?.cartItems || []), newItem];
      }
      const result = { ...state, cartItems: newCartItems };
      update_cart_event(result, false, true);
      // Return a new state object with updated cart items
      return result;

    case "update":
      // Your logic to update an item in the cart
      const { item_id, qty } = action.payload;
      const updated_result = {
        ...state,
        cartItems: state?.cartItems?.map((item) =>
          item.item_id === item_id ? { ...item, qty: qty } : item
        ),
      };
      action?.payload?.from_mini_cart
        ? update_cart_event(updated_result, action?.payload?.from_mini_cart)
        : null;
      return updated_result;

    case "remove":
      const remove_res = {
        ...state,
        cartItems: state?.cartItems?.filter(
          (item) => item.item_id !== action.payload.item_id
        ),
      };
      update_cart_event(remove_res, false, action?.payload?.from_mini_cart);
      return remove_res;

    case "shipping_address":
      return {
        ...state,
        shippingAddress: action.payload,
      };
    case "clear":
      return {
        cart: {},
        cartItems: [],
        shippingAddress: null,
      };
    default:
      return state;
  }
};
